import './TermsPage.css';

const TermsPage = () => {
  const currentDate = new Date().toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="container">
          <h1 className="terms-hero-title">Terms and Conditions</h1>
          <p className="terms-hero-subtitle">
            Please read these terms carefully before using our platform. By using 12thPlus.com, you agree to these terms.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section terms-content">
        <div className="container">
          <div className="terms-card">
            {/* Introduction */}
            <div className="terms-section">
              <p>
                The terms "We" / "Us" / "Our" / "Company" individually and collectively refer to GooCampus Edu Solutions Private Limited and the terms "Visitor" and "User" refer to the users.
              </p>
              <p>
                This page states the Terms and Conditions under which you (Visitor) may visit this website ("Website"). Please read this page carefully. If you do not accept the Terms and Conditions stated here, we would request you to exit this site. The business, any of its business divisions and / or its companies or subsidiaries to subsidiaries or such other investment companies (in India or abroad) reserve their respective rights to revise these Terms and Conditions at any time by updating this posting.
              </p>
              <p>
                You should visit this page periodically to re-appraise yourself of the Terms and Conditions, because they are binding on all users of this Website.
              </p>
            </div>

            <div className="terms-divider"></div>

            {/* Use of Content */}
            <div className="terms-section">
              <h2>Use of Content</h2>
              <p>
                All logos, brands, marks headings, labels, names, signatures, numerals, shapes or any combinations thereof, appearing in this site, except as otherwise noted, are properties either owned, or used under license, by the business and / or its associate entities who feature on this Website.
              </p>
              <p>
                The use of these properties or any other content on this site, except as provided in these terms and conditions or in the site content, is strictly prohibited.
              </p>
              <p>
                You may not sell or modify the content of this Website or reproduce, display, publicly perform, distribute, or otherwise use the materials in any way for any public or commercial purpose without the respective organization's or entity's written permission.
              </p>
            </div>

            <div className="terms-divider"></div>

            {/* Acceptable Website Use */}
            <div className="terms-section">
              <h2>Acceptable Website Use</h2>

              <h3>Security Rules</h3>
              <p>
                Visitors are prohibited from violating or attempting to violate the security of the Website, including, without limitation:
              </p>
              <ol>
                <li>
                  Accessing data not intended for such user or logging into a server or account which the user is not authorized to access
                </li>
                <li>
                  Attempting to probe, scan or test the vulnerability of a system or network or to breach security or authentication measures without proper authorization
                </li>
                <li>
                  Attempting to interfere with service to any user, host or network, including, without limitation, via means of submitting a virus or "Trojan horse" to the Website, overloading, "flooding", "mail bombing" or "crashing"
                </li>
                <li>
                  Sending unsolicited electronic mail, including promotions and/or advertising of products or services
                </li>
              </ol>
              <p>
                Violations of system or network security may result in civil or criminal liability. The business and / or its associate entities will have the right to investigate occurrences that they suspect as involving such violations and will have the right to involve, and cooperate with, law enforcement authorities in prosecuting users who are involved in such violations.
              </p>

              <h3>General Rules</h3>
              <p>
                Visitors may not use the Website in order to transmit, distribute, store or destroy material:
              </p>
              <ul>
                <li>
                  That could constitute or encourage conduct that would be considered a criminal offence or violate any applicable law or regulation
                </li>
                <li>
                  In a manner that will infringe the copyright, trademark, trade secret or other intellectual property rights of others or violate the privacy or publicity of other personal rights of others
                </li>
                <li>
                  That is libelous, defamatory, pornographic, profane, obscene, threatening, abusive or hateful
                </li>
              </ul>
            </div>

            <div className="terms-divider"></div>

            {/* Indemnity */}
            <div className="terms-section">
              <h2>Indemnity</h2>
              <p>
                The User unilaterally agree to indemnify and hold harmless, without objection, the Company, its officers, directors, employees and agents from and against any claims, actions and/or demands and/or liabilities and/or losses and/or damages whatsoever arising from or resulting from their use of www.12thplus.com or their breach of the terms.
              </p>
            </div>

            <div className="terms-divider"></div>

            {/* Liability */}
            <div className="terms-section">
              <h2>Liability</h2>
              <p>
                User agrees that neither Company nor its group companies, directors, officers or employees shall be liable for any direct and/or indirect and/or incidental and/or special and/or consequential and/or exemplary damages, resulting from the use and/or the inability to use the service and/or for cost of procurement of substitute goods and/or services or resulting from any goods and/or data and/or information and/or services purchased and/or obtained and/or messages received and/or transactions entered into through and/or from the service.
              </p>
              <p>
                This includes but is not limited to damages resulting from unauthorized access to and/or alteration of user's transmissions and/or data and/or arising from any other matter relating to the service, including but not limited to, damages for loss of profits and/or use and/or data or other intangible, even if Company has been advised of the possibility of such damages.
              </p>
              <p>
                User further agrees that Company shall not be liable for any damages arising from interruption, suspension or termination of service, including but not limited to direct and/or indirect and/or incidental and/or special consequential and/or exemplary damages, whether such interruption and/or suspension and/or termination was justified or not, negligent or intentional, inadvertent or advertent.
              </p>
              <p>
                User agrees that Company shall not be responsible or liable to user, or anyone, for the statements or conduct of any third party of the service. In sum, in no event shall Company's total liability to the User for all damages and/or losses and/or causes of action exceed the amount paid by the User to Company, if any, that is related to the cause of action.
              </p>
            </div>

            <div className="terms-divider"></div>

            {/* Communication Authorization */}
            <div className="terms-section">
              <h2>Communication Authorization</h2>
              <p>
                By using the website and/or registering yourself at www.12thplus.com, you authorize us to contact you via email or phone call or SMS and offer you our services, imparting product knowledge, offer promotional offers running on website & offers offered by the associated third parties, for which reasons, personally identifiable information may be collected.
              </p>
              <p>
                And irrespective of the fact if also you have registered yourself under DND or DNC or NCPR service, you still authorize us to give you a call from 12thPlus for the above mentioned purposes till 365 days of your registration with us.
              </p>
            </div>

            <div className="terms-divider"></div>

            {/* Information Collection and Use */}
            <div className="terms-section">
              <h2>Information Collection and Use</h2>
              <p>
                This Privacy Policy covers 12thPlus treatment of personally identifiable information that 12thPlus collects when you are on the 12thPlus site, and when you use 12thPlus services.
              </p>
              <p>
                This policy also covers 12thPlus treatment of personally identifiable information that 12thPlus business partner shares with 12thPlus. This policy does not apply to certain 12thPlus products or services, when you visit 12thPlus pages, and when you enter promotions.
              </p>
              <p>
                12thPlus may also receive personally identifiable information from our business partners. When you register with 12thPlus, we may ask for your first name, last name, contact number, email, location and gender.
              </p>
              <p>
                Once you register with 12thPlus and sign in to our services, you are not anonymous to us. Also during registration, you may be requested to register your mobile phone and email id, pager, or other device to receive text messages, and other services to your wireless device.
              </p>
              <p>
                By registration you authorize us to send SMS/email alerts to you for your login details and any other service requirements or some advertising messages/emails from us.
              </p>
            </div>

            <div className="terms-divider"></div>

            {/* Disclaimer */}
            <div className="terms-section">
              <h2>Disclaimer of Consequential Damages</h2>
              <p>
                In no event shall Company or any parties, organizations or entities associated with the corporate brand name us or otherwise, mentioned at this Website be liable for any damages whatsoever (including, without limitations, incidental and consequential damages, lost profits, or damage to computer hardware or loss of data information or business interruption) resulting from the use or inability to use the Website and the Website material, whether based on warranty, contract, tort, or any other legal theory, and whether or not, such organization or entities were advised of the possibility of such damages.
              </p>
            </div>

            {/* Last Updated */}
            <div className="terms-footer">
              <p>Last updated: {currentDate}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
